module.exports = __webpack_public_path__ + "r-v3/img/ml_32_01.47911985.jpg";